import { render, staticRenderFns } from "./Etapa11.vue?vue&type=template&id=eba6b83e&scoped=true"
import script from "./Etapa11.vue?vue&type=script&lang=js"
export * from "./Etapa11.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=eba6b83e&prod&scoped=true&lang=scss&external"
import style1 from "./Etapa11.vue?vue&type=style&index=1&id=eba6b83e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba6b83e",
  null
  
)

export default component.exports